import React, { useEffect, useState, useCallback } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  Badge,
  Input,
  Spinner,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";

import TulufaliLogo from "../../components/Icons/tulufali_logo.svg";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

import s from "./Tables.module.scss";
import {
  API_TIMEOUT,
  PROGRESS_BANTUAN_API,
  GET_BANTUAN_TAHUN_KATEGORI,
} from "../../utils/index.js";
import axios from "axios";
import { numberWithCommas } from "../../utils/func.js";

function isInputSelesai(item) {
  return (item.jumlahpenerima || 0) >= (item.jmlPenerima || 0);
}

function matchesStatusFilter(item, filter) {
  if (filter === "onprogress") return !isInputSelesai(item);
  if (filter === "selesai") return isInputSelesai(item);
  return true;
}

const TableProgressSemua = function () {
  const [fullTableData, setFullTableData] = useState([]);
  const [firstTableCurrentPage, setFirstTableCurrentPage] = useState(0);
  const [modalDelete, setModalDelete] = useState(false);
  const [listPenerima, setListPenerima] = useState([]);
  const currentYear = new Date().getFullYear();
  const [simpleDropdownValue2, setSimpleDropdownValue2] = useState(String(currentYear));
  const [selectedDinas, setSelectedDinas] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [bantuanModal, setBantuanModal] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [isLoadingModalDetail, setIsLoadingModalDetail] = useState(false);

  const containerStyle = {
    width: "100%",
    height: "300px",
    overflow: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#888888 #f0f0f0",
  };

  const ambilProgresBantuan = useCallback((tahun) => {
    const tahunStr = String(tahun).trim();
    if (!tahunStr) return;
    setIsLoadingData(true);
    axios({
      method: "get",
      url: PROGRESS_BANTUAN_API + tahunStr,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) return;
        const data = response.data?.data ?? [];
        setFullTableData(data);
      })
      .catch((error) => {
        alert(error?.message || "Gagal mengambil data");
      })
      .finally(() => setIsLoadingData(false));
  }, []);

  useEffect(() => {
    ambilProgresBantuan(simpleDropdownValue2);
  }, [simpleDropdownValue2, ambilProgresBantuan]);

  const listTahun = Array.from({ length: currentYear - 2018 + 1 }, (_, i) => ({
    tahun: 2018 + i,
  }));

  const handleTahunChange = (tahunBaru) => {
    setFullTableData([]);
    setIsLoadingData(true);
    setSimpleDropdownValue2(String(tahunBaru));
    setSelectedDinas("");
    setStatusFilter("");
    setFirstTableCurrentPage(0);
  };

  const ambilDataBantuanTahun = (data) => {
    axios({
      method: "post",
      url: GET_BANTUAN_TAHUN_KATEGORI,
      timeout: API_TIMEOUT,
      data: data,
    })
      .then((response) => {
        if (response.status !== 200) return;
        setListPenerima(response.data?.data ?? []);
      })
      .catch((error) => {
        alert(error?.message || "Gagal mengambil data");
        setListPenerima([]);
      })
      .finally(() => setIsLoadingModalDetail(false));
  };

  const pageSize = 100;

  const setFirstTablePage = (e, index) => {
    e.preventDefault();
    setFirstTableCurrentPage(index);
  };

  const getDesilLabel = (desil) => {
    if (desil == null || desil === undefined || desil === "")
      return "Di atas desil 5 (>D5)";
    const map = {
      1: "Sangat Miskin (D1)",
      2: "Miskin (D2)",
      3: "Rentan Miskin (D3)",
      4: "Hampir Rentan (D4)",
      5: "Menengah Bawah (D5)",
    };
    return map[Number(desil)] || "Di atas desil 5 (>D5)";
  };

  const openModal = (data) => {
    setModalDelete(true);
    setIsLoadingModalDetail(true);
    ambilDataBantuanTahun(data);
  };

  const closeModal = () => {
    setModalDelete(false);
    setIsLoadingModalDetail(false);
  };

  const handleDownloadModalPdf = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    let startY = 15;

    try {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = TulufaliLogo;
      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
      });
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth || img.width;
      canvas.height = img.naturalHeight || img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const logoData = canvas.toDataURL("image/png");
      doc.addImage(logoData, "PNG", 14, 10, 20, 20);
    } catch (_) {}
    startY = 32;

    doc.setFontSize(12);
    doc.text(`Detail Penerima - ${bantuanModal}`, 14, startY);
    startY += 8;

    doc.setFontSize(9);
    const head = [["No", "Nama", "NIK", "Desa", "Desil / Kategori"]];
    const body = (listPenerima || []).map((r, i) => [
      String(i + 1),
      r.nama || "-",
      r.nik || "-",
      r.desa || "-",
      getDesilLabel(r.desil_nasional),
    ]);
    doc.autoTable({
      startY,
      head,
      body,
      theme: "grid",
      headStyles: { fillColor: [77, 83, 224] },
    });
    const tableEndY = doc.lastAutoTable.finalY;
    startY = tableEndY + 8;

    const cntD1 = (listPenerima || []).filter((r) => r.desil_nasional === 1).length;
    const cntD2 = (listPenerima || []).filter((r) => r.desil_nasional === 2).length;
    const cntD3 = (listPenerima || []).filter((r) => r.desil_nasional === 3).length;
    const cntD4 = (listPenerima || []).filter((r) => r.desil_nasional === 4).length;
    const cntD5 = (listPenerima || []).filter((r) => r.desil_nasional === 5).length;
    const total = (listPenerima || []).length;
    const cntAboveD5 = Math.max(0, total - cntD1 - cntD2 - cntD3 - cntD4 - cntD5);

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Rekapan Desil:", 14, startY);
    startY += 6;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(
      `D1: ${cntD1}   D2: ${cntD2}   D3: ${cntD3}   D4: ${cntD4}   D5: ${cntD5}   >D5: ${cntAboveD5}   Total: ${total}`,
      14,
      startY
    );
    startY += 12;

    const now = new Date();
    const dateStr = now.toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const timeStr = now.toLocaleTimeString("id-ID", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text(
      `Unduh dari Tulufali App - ${dateStr} ${timeStr}`,
      14,
      doc.internal.pageSize.height - 10
    );
    doc.setTextColor(0, 0, 0);

    doc.save(`Detail-Penerima-${bantuanModal.replace(/\s+/g, "-")}.pdf`);
  };

  const listDinas = [...new Set(fullTableData.map((r) => r.dinas).filter(Boolean))].sort();

  const byDinas = !selectedDinas
    ? fullTableData
    : fullTableData.filter((r) => r.dinas === selectedDinas);

  const recapData = byDinas.filter((row) => matchesStatusFilter(row, statusFilter));
  const displayTable = recapData;

  const totalPenerima = recapData.reduce((acc, r) => acc + (parseInt(r.jumlahpenerima, 10) || 0), 0);
  const totalUang = recapData.reduce((acc, r) => acc + (parseInt(r.totalUang, 10) || 0), 0);
  const sumDesil1 = recapData.reduce((acc, r) => acc + (parseInt(r.totalDesil1, 10) || 0), 0);
  const sumDesil2 = recapData.reduce((acc, r) => acc + (parseInt(r.totalDesil2, 10) || 0), 0);
  const sumDesil3 = recapData.reduce((acc, r) => acc + (parseInt(r.totalDesil3, 10) || 0), 0);
  const pctDesil1 = totalPenerima > 0 ? ((sumDesil1 / totalPenerima) * 100).toFixed(1) : "0";
  const pctDesil2 = totalPenerima > 0 ? ((sumDesil2 / totalPenerima) * 100).toFixed(1) : "0";
  const pctDesil3 = totalPenerima > 0 ? ((sumDesil3 / totalPenerima) * 100).toFixed(1) : "0";
  const sumPenerimaDiAtasDesil3 = Math.max(0, totalPenerima - sumDesil1 - sumDesil2 - sumDesil3);
  const pctDiAtasDesil3 =
    totalPenerima > 0
      ? ((sumPenerimaDiAtasDesil3 / totalPenerima) * 100).toFixed(1)
      : "0";
  const firstTablePagesCount = Math.ceil(displayTable.length / pageSize) || 1;

  return (
    <div>
      <Row>
        <Col>
          <Row className="mb-4">
            <Col>
              <Widget>
                <div className={s.tableTitleStack}>
                  <div className={s.tableTitleHeadline}>
                    <div className="headline-2">
                      Semua Bantuan — On Progress &amp; Selesai Input
                    </div>
                  </div>

                  <div className={s.filterToolbar}>
                    <div className={s.filterItem}>
                      <label className={s.filterLabel}>Tahun</label>
                      <Input
                        type="select"
                        value={simpleDropdownValue2}
                        onChange={(e) => handleTahunChange(e.target.value)}
                        className={s.filterSelect}
                      >
                        {listTahun.map((item) => (
                          <option key={item.tahun} value={item.tahun}>
                            {item.tahun}
                          </option>
                        ))}
                      </Input>
                    </div>
                    <div className={s.filterItem}>
                      <label className={s.filterLabel}>Dinas</label>
                      <Input
                        type="select"
                        value={selectedDinas}
                        onChange={(e) => {
                          setSelectedDinas(e.target.value);
                          setFirstTableCurrentPage(0);
                        }}
                        className={s.filterSelect}
                      >
                        <option value="">Semua Dinas</option>
                        {listDinas.map((d) => (
                          <option key={d} value={d}>
                            {d}
                          </option>
                        ))}
                      </Input>
                    </div>
                    <div className={s.filterItem}>
                      <label className={s.filterLabel}>Status input</label>
                      <Input
                        type="select"
                        value={statusFilter}
                        onChange={(e) => {
                          setStatusFilter(e.target.value);
                          setFirstTableCurrentPage(0);
                        }}
                        className={s.filterSelect}
                      >
                        <option value="">Semua (on progress &amp; selesai)</option>
                        <option value="onprogress">On progress</option>
                        <option value="selesai">Selesai input</option>
                      </Input>
                    </div>
                  </div>
                </div>
                <div className={`d-flex flex-wrap align-items-center mb-3 ${s.summaryChipsWrap}`}>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Persen Desil 1</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {pctDesil1}%
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Persen Desil 2</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {pctDesil2}%
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Persen Desil 3</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {pctDesil3}%
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Persen di Atas Desil 3</span>
                    <Badge color="primary" pill className={s.summaryChipValue}>
                      {pctDiAtasDesil3}%
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Total Penerima</span>
                    <Badge color="info" pill className={s.summaryChipValue}>
                      {numberWithCommas(totalPenerima)}
                    </Badge>
                  </span>
                  <span className={s.summaryChip}>
                    <span className={s.summaryChipLabel}>Total Uang</span>
                    <Badge color="success" pill className={s.summaryChipValue}>
                      {numberWithCommas(totalUang)}
                    </Badge>
                  </span>
                </div>
                <div
                  className={`widget-table-overflow ${s.progressTableWrap} ${s.progressInputTableMinimal} ${isLoadingData ? s.tableLoading : ""}`}
                >
                  {isLoadingData && (
                    <div className={s.tableLoadingOverlay}>
                      <Spinner color="primary" />
                      <span className={s.loadingText}>Memuat data...</span>
                    </div>
                  )}
                  {!isLoadingData && displayTable.length === 0 ? (
                    <div
                      className={`d-flex align-items-center justify-content-center py-5 ${s.emptyTableMsg}`}
                    >
                      <span className={s.loadingText}>
                        Tidak ada bantuan untuk filter ini
                      </span>
                    </div>
                  ) : (
                    <Table
                      className={`table-striped table-borderless ${s.statesTable}`}
                      responsive
                    >
                      <thead>
                        <tr>
                          <th className="w-10">No</th>
                          <th className="w-25">BANTUAN</th>
                          <th className="w-25">TAHUN</th>
                          <th className="w-25">DINAS</th>
                          <th className="w-25">TOTAL PENERIMA</th>
                          <th className="w-25">PENERIMA</th>
                          <th className={s.progressMiskinEkstrimHeader}>
                            Miskin Ekstrim
                            <span className="subLabel">(dalam kurun Desil 1)</span>
                          </th>
                          <th className={s.progressDesilCol}>DESIL</th>
                          <th className="w-20">Kategori</th>
                          <th className="w-25">STATUS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayTable
                          .slice(
                            firstTableCurrentPage * pageSize,
                            (firstTableCurrentPage + 1) * pageSize
                          )
                          .map((item, idx) => (
                            <tr key={item.id || uuidv4()}>
                              <td>{firstTableCurrentPage * pageSize + idx + 1}</td>
                              <td className="d-flex align-items-center">
                                <span className="ml-3">{item.bantuan}</span>
                              </td>
                              <td>{item.tahun}</td>
                              <td>{item.dinas}</td>
                              <td>{item.jmlPenerima}</td>
                              <td>
                                <div className="d-flex justify-content-between">
                                  <div className="d-flex flex-column mt-3">
                                    <div className={s.activity}>
                                      <p className="body-2">
                                        {Math.round(
                                          (item.jumlahpenerima / item.jmlPenerima) * 100
                                        )}
                                        % Input Penerima{" "}
                                      </p>
                                      <p className="body-2">
                                        {item.jumlahpenerima}
                                        <span className="body-3 muted">
                                          /{item.jmlPenerima}
                                        </span>
                                      </p>
                                    </div>
                                    <Progress
                                      color={
                                        (item.jumlahpenerima / item.jmlPenerima) * 100 >
                                        50
                                          ? "success"
                                          : "danger"
                                      }
                                      className="progress-xs"
                                      value={
                                        (item.jumlahpenerima / item.jmlPenerima) * 100
                                      }
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex justify-content-between">
                                  <div className="d-flex flex-column mt-3">
                                    <div className={s.activity}>
                                      <p className="body-2">
                                        {Math.round(
                                          (item.jumlahmiskinekstrim / item.jmlPenerima) *
                                            100
                                        )}
                                        % Miskin Esktrim{" "}
                                      </p>
                                      <p className="body-2">
                                        {item.jumlahmiskinekstrim}
                                        <span className="body-3 muted">
                                          /{item.jmlPenerima}
                                        </span>
                                      </p>
                                    </div>
                                    <Progress
                                      color={
                                        (item.jumlahmiskinekstrim / item.jmlPenerima) *
                                          100 >
                                        50
                                          ? "success"
                                          : "danger"
                                      }
                                      className="progress-xs"
                                      value={
                                        (item.jumlahmiskinekstrim / item.jmlPenerima) *
                                        100
                                      }
                                    />
                                  </div>
                                </div>
                              </td>
                              <td className={s.progressDesilCol}>
                                <div className={s.desilCellContent}>
                                  <span className={s.desilItem}>
                                    <span className={s.desilLabel}>D1</span>
                                    {item.totalDesil1 ?? 0}
                                  </span>
                                  <span className={s.desilItem}>
                                    <span className={s.desilLabel}>D2</span>
                                    {item.totalDesil2 ?? 0}
                                  </span>
                                  <span className={s.desilItem}>
                                    <span className={s.desilLabel}>D3</span>
                                    {item.totalDesil3 ?? 0}
                                  </span>
                                  <span className={s.desilItem}>
                                    <span className={s.desilLabel}>D4</span>
                                    {item.totalDesil4 ?? 0}
                                  </span>
                                  <span className={s.desilItem}>
                                    <span className={s.desilLabel}>D5</span>
                                    {item.totalDesil5 ?? 0}
                                  </span>
                                  <span className={s.desilItem}>
                                    <span className={s.desilLabel}>&gt;D5</span>
                                    {Math.max(
                                      0,
                                      (item.jumlahpenerima ?? 0) -
                                        ((item.totalDesil1 ?? 0) +
                                          (item.totalDesil2 ?? 0) +
                                          (item.totalDesil3 ?? 0) +
                                          (item.totalDesil4 ?? 0) +
                                          (item.totalDesil5 ?? 0))
                                    )}
                                  </span>
                                </div>
                              </td>
                              <td className={s.kategoriCell}>
                                <span
                                  className={
                                    isInputSelesai(item)
                                      ? s.kategoriChipSelesai
                                      : s.kategoriChipProgress
                                  }
                                >
                                  {isInputSelesai(item)
                                    ? "Selesai"
                                    : "Progress"}
                                </span>
                              </td>
                              <td>
                                {(item.jumlahpenerima / item.jmlPenerima) * 100 == 100 &&
                                (item.jumlahmiskinekstrim / item.jmlPenerima) * 100 ==
                                  100 ? (
                                  <Button
                                    className={`${s.controlBtn} mx-2`}
                                    color="success"
                                    size="xs"
                                    onClick={() => {
                                      const data = {};
                                      data.bantuan = item.bantuan;
                                      data.tahun = item.tahun;
                                      setBantuanModal(item.bantuan);
                                      openModal(data);
                                    }}
                                  >
                                    Selesai
                                  </Button>
                                ) : (
                                  <Button
                                    className={s.controlBtn}
                                    color="primary"
                                    size="xs"
                                    onClick={() => {
                                      const data = {};
                                      data.bantuan = item.bantuan;
                                      data.tahun = item.tahun;
                                      setBantuanModal(item.bantuan);
                                      openModal(data);
                                    }}
                                  >
                                    Detail
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  )}
                  {displayTable.length > 0 && (
                    <Pagination
                      className="pagination-borderless"
                      aria-label="Page navigation example"
                    >
                      <PaginationItem disabled={firstTableCurrentPage <= 0}>
                        <PaginationLink
                          onClick={(e) => setFirstTablePage(e, firstTableCurrentPage - 1)}
                          previous
                          href="#top"
                        />
                      </PaginationItem>
                      {[...Array(firstTablePagesCount)].map((page, i) => (
                        <PaginationItem active={i === firstTableCurrentPage} key={i}>
                          <PaginationLink
                            onClick={(e) => setFirstTablePage(e, i)}
                            href="#top"
                          >
                            {i + 1}
                          </PaginationLink>
                        </PaginationItem>
                      ))}
                      <PaginationItem
                        disabled={firstTableCurrentPage >= firstTablePagesCount - 1}
                      >
                        <PaginationLink
                          onClick={(e) => setFirstTablePage(e, firstTableCurrentPage + 1)}
                          next
                          href="#top"
                        />
                      </PaginationItem>
                    </Pagination>
                  )}
                </div>
              </Widget>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal size="md" isOpen={modalDelete} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>{bantuanModal}</ModalHeader>
        <ModalBody>
          <Widget className="widget-p-md">
            <div style={containerStyle}>
              {isLoadingModalDetail ? (
                <div
                  className={`d-flex flex-column align-items-center justify-content-center py-5 ${s.modalLoadingWrap}`}
                >
                  <Spinner color="primary" />
                  <span className={s.loadingText}>Memuat data penerima...</span>
                </div>
              ) : (
                <ul className="list-group">
                  {listPenerima && listPenerima.length > 0 ? (
                    listPenerima.map((item) => (
                      <li className="list-group-item" key={item.id}>
                        <div className={s.listBadge}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            {item.nama} <code>{item.desa}</code> {item.nik}
                            <code>{getDesilLabel(item.desil_nasional)}</code>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                              <Badge
                                color="secondary-red"
                                style={{ cursor: "pointer", marginRight: 5 }}
                                onClick={() => {}}
                              >
                                <i className="fa fa-info mr-2" />
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))
                  ) : (
                    <div className={s.listBadge}>Belum ada data</div>
                  )}
                </ul>
              )}
            </div>
          </Widget>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeModal()}>
            Ok
          </Button>
          <Button color="primary" onClick={handleDownloadModalPdf}>
            Download PDF
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default TableProgressSemua;
